import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { MAX_PLAYERS, MIN_PLAYERS } from '@sincronia/shared';
import { BrandMark } from '../components/Brand.js';
import { Panel } from '../components/ui.js';
import { useT, type MessageKey } from '../i18n/index.js';

const SECTIONS: { title: MessageKey; body: MessageKey }[] = [
  { title: 'howto.goalTitle', body: 'howto.goal' },
  { title: 'howto.turnsTitle', body: 'howto.turns' },
  { title: 'howto.errorsTitle', body: 'howto.errors' },
  { title: 'howto.starTitle', body: 'howto.star' },
  { title: 'howto.timerTitle', body: 'howto.timer' },
  { title: 'howto.installTitle', body: 'howto.install' },
];

export function HowToPlayPage(): ReactNode {
  const t = useT();

  return (
    <main className="safe-x safe-bottom safe-top mx-auto flex w-full max-w-md flex-1 flex-col gap-6 px-5 py-8">
      <header className="flex items-center gap-3">
        <BrandMark size={40} animated={false} />
        <h1 className="text-2xl font-semibold text-night-200">{t('howto.title')}</h1>
      </header>

      <p className="text-sm text-night-300">
        {MIN_PLAYERS}–{MAX_PLAYERS} jogadores · {t('app.tagline')}
      </p>

      <div className="flex flex-col gap-4">
        {SECTIONS.map((section) => (
          <Panel key={section.title} className="flex flex-col gap-2">
            <h2 className="text-lg font-semibold text-night-200">{t(section.title)}</h2>
            <p className="text-sm leading-relaxed text-night-300">{t(section.body)}</p>
          </Panel>
        ))}
      </div>

      <Link to="/" className="mt-2 text-center text-sm text-pulse-400 underline underline-offset-4">
        {t('common.back')}
      </Link>
    </main>
  );
}
